// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__Wky60","vLegacy":"SelectSecondary_vLegacy__1e16A","error":"SelectSecondary_error__2Kkbz","disabled":"SelectSecondary_disabled__3AayF"};